export const politicalDivisionMixin = {
	computed: {
		getPoliticalDivision() {
			const countryInfo = {
				ARGENTINA: {department: this.$t("Province"), city: this.$t("Municipality")},
				BRASIL: {department: this.$t("State"), city: this.$t("City")},
				CHILE: {department: this.$t("Region"), city: this.$t("Commune")},
				COLOMBIA: {department: this.$t("Department"), city: this.$t("City")},
				COSTA_RICA: {department: this.$t("Province"), city: this.$t("Canton")},
				ECUADOR: {department: this.$t("Province"), city: this.$t("Canton")},
				GUATEMALA: {department: this.$t("Department"), city: this.$t("Municipality")},
				MEXICO: {department: this.$t("State"), city: this.$t("Municipality")},
				PARAGUAY: {department: this.$t("Department"), city: this.$t("District")},
				PERU: {department: this.$t("Region"), city: this.$t("Province")},
			};
			const normalizedCountry =
				this.selectedCountry != null && typeof this.selectedCountry === "object"
					? this.selectedCountry.value != null && this.selectedCountry.value != undefined
						? this.selectedCountry.value.toUpperCase().replace(" ", "_")
						: ""
					: this.selectedCountry;
			const selectedCountryInfo = countryInfo[normalizedCountry];
			if (!selectedCountryInfo) {
				return countryInfo["COLOMBIA"];
			}
			return selectedCountryInfo;
		},
	},
};
